// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the DB Icon.
 *
 * @component
 * @param {DBIconProps} props - The DBIconProps for the DBIcon component.
 * @returns {ReactElement} The GraphIcon component.
 */
export const DBIcon = (props: IconProps) => {
  return (
    <Icon viewBox='0 0 27 30' {...props}>
      <path
        d='M26.129 4.6875V7.5C26.129 10.0898 20.2792 12.1875 13.0645 12.1875C5.84987 12.1875 0 10.0898 0 7.5V4.6875C0 2.09883 5.84987 0 13.0645 0C20.2792 0 26.129 2.09883 26.129 4.6875ZM22.9329 12.5801C24.0935 12.1465 25.26 11.5898 26.129 10.9043V16.875C26.129 19.4648 20.2792 21.5625 13.0645 21.5625C5.84987 21.5625 0 19.4648 0 16.875V10.9043C0.870773 11.5898 1.98417 12.1465 3.19906 12.5801C5.81254 13.5176 9.30264 14.0625 13.0645 14.0625C16.8264 14.0625 20.3142 13.5176 22.9329 12.5801ZM3.19906 21.9551C5.81254 22.8926 9.30264 23.4375 13.0645 23.4375C16.8264 23.4375 20.3142 22.8926 22.9329 21.9551C24.0935 21.5215 25.26 20.9648 26.129 20.2793V25.3125C26.129 27.9023 20.2792 30 13.0645 30C5.84987 30 0 27.9023 0 25.3125V20.2793C0.870773 20.9648 1.98417 21.5215 3.19906 21.9551Z'
        fill='url(#paint0_linear_784_11319)'
        fillOpacity='0.46'
      />
      <defs>
        <linearGradient
          id='paint0_linear_784_11319'
          x1='30.6963'
          y1='6.92306'
          x2='-6.58724'
          y2='7.4541'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#8484A0' />
          <stop offset='1' stopColor='#DAD9E2' />
        </linearGradient>
      </defs>
    </Icon>
  );
};
